import { createAction } from '@reduxjs/toolkit';

export const SHOW_DISPOSITION_ACTION_TYPE = 'saga/showDisposition';
export const showDispositionAction = createAction(SHOW_DISPOSITION_ACTION_TYPE);
